import axios from "../axiosConfig";

class Routes {
  getAllClients = () => {
    let data = axios.get("/api/clients/");
    return data;
  };

  getClientById = (id) => {
    let data = axios.get(`/api/clients/${id}`);
    return data;
  };

  createClient = (val) => {
    let data = axios.post("/api/clients/", val);
    return data;
  };

  updateClient = (id, val) => {
    let data = axios.put(`/api/clients/${id}`, val);
    return data;
  };

  deleteClient = (id) => {
    const data = axios.delete(`/api/clients/${id}`);
    return data;
  };
}

export default new Routes();

